export default "__VITE_ASSET__2b41cde7__"